import { createAsyncThunk } from "@reduxjs/toolkit";
import { ReportExportService } from "../../services/ReportExportService";
import {
  ReportExportResponse,
  ReportExportRequest,
} from "../../models/ReportExport.model";

export const ExportToExcel = createAsyncThunk<
  ReportExportResponse,
  {
    reportData: Omit<
      ReportExportRequest,
      "exportFormat" | "token" | "companyKey"
    >;
    token: string;
    companyKey: string;
  },
  { rejectValue: string }
>(
  "reportExcel/export",
  async ({ reportData, token, companyKey }, { rejectWithValue }) => {
    try {
      const result = await ReportExportService.exportReport(
        reportData,
        "excel",
        token,
        companyKey,
      );
      if (!result.success) {
        return rejectWithValue(result.message || "Failed to export Excel");
      }
      return result;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
